import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
} from "@mui/material";
import AddBox from "@mui/icons-material/AddBox";
import PaymentIcon from "@mui/icons-material/Payment";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useSnackbar } from "notistack";
import { translate } from "../../../config/lang";
import { currencySymbol } from "../../../config/values";
import { defaultVariables } from "../../../config";
import CurrencyTextField from "../../components/elements/fields/CurrencyTextField";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import NumberField from "../../components/elements/fields/NumberField";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";
import {updateRedux} from "../../../config/Security";
import {isAdmin} from "../../../config/Permissions";
import {connect} from "trim-redux";
import {payPagePath, walletDepositGatewayFromSetting} from "../../../config/paymentGateway";

const DepositMoneyDialog = ({ amount = 500, redirect, variant, style, purchase, width, classes, reload, setting }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [amountValue, setAmountValue] = useState(amount);
    const [error, setError] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const location = useLocation();
    const navigation = useNavigate();
    const depositGateway = walletDepositGatewayFromSetting(setting);

    const handleChange = (inputValue) => {
        setAmountValue(inputValue);
        setError(inputValue > 100 ? "" : translate("wrongPrice"));
    };

    const handleRequest = async () => {
        const data = new FormData();
        data.append('amount', amountValue);
        localStorage.setItem("payment_redirect_url", location.pathname);
        localStorage.setItem("payment_redirect_text", t('viewTransactions'));

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };
        try {
            await axios.post(`${defaultVariables.url}/wallets/deposit`, data, config).then(response => {
                setOpen(false);
                navigation(payPagePath(depositGateway, response.data.id));
            })
        } catch (error) {
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            setSubmitLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        if (amount > 10) {
            handleRequest();
        } else {
            setError(t('wrongPrice'));
            setSubmitLoading(false);
        }
    };

    const toggleDialog = () => setOpen(!open);

    return (
        <>
            {purchase ? (
                <Button
                    variant={variant || "contained"}
                    color="primary"
                    style={style}
                    startIcon={<AddBox />}
                    onClick={toggleDialog}
                    //disabled={!isAdmin()}
                >
                    {t("depositMoney")}
                </Button>
            ) : width !== "xs" ? (
                <Button
                    variant={variant || "contained"}
                    color="primary"
                    style={style}
                    startIcon={<AddBox />}
                    onClick={toggleDialog}
                    //disabled={!isAdmin()}
                >
                    {t("depositMoney")}
                </Button>
            ) : (
                <IconButton color="secondary" onClick={toggleDialog} /*disabled={!isAdmin()}*/>
                    <AddBox />
                </IconButton>
            )}

            <Dialog
                fullWidth
                maxWidth="xs"
                open={open}
                onClose={toggleDialog}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t("depositMoney")}
                    <IconButton
                        onClick={toggleDialog}
                        size="small"
                        className={classes.dialogClose}
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{marginBottom:10}}>{t("depositMoneyDescription")}</DialogContentText>
                    <NumberField
                        fullWidth
                        label={t('amount')}
                        variant="outlined"
                        value={amountValue}
                        endAdornment={currencySymbol}
                        decimals={2}
                        min={0}
                        onChange={(res) => handleChange(res)}
                        error={!!error}
                        helperText={error}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubmit} variant="contained" color="primary" startIcon={<PaymentIcon />} disabled={submitLoading}>
                        {t('purchase')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const mstp = (state) => ({ setting: state.setting });

export default withStyles(Styles)(connect(mstp)(DepositMoneyDialog));
